// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1t6EB","signatureBlock":"Footer_signatureBlock__1Lbuc","signature":"Footer_signature__3xGQJ"};